module.exports = __webpack_public_path__ + "static/img/create-catalog@2x.466aed46.svg";